import React from 'react';
import './MainHomeImage.css';

function MainHomeImage() {
  return (
    <img className="main-home-image" src="/images/MainHomeImage.JPG" alt="devotional heart" priority="true"></img>
  );
}

export default MainHomeImage;